<template>
  <div class="home">
    <top></top>
    <vue-swpier :items="slide" autoplay="5000"></vue-swpier>
    <div class="cats">
      <div
        class="cat"
        v-for="cat in categorys"
        :key="cat.id"
        v-on:click="$router.push('/shop/category/'+cat.id)"
      >
        <img :src="cat.pic" />
        <div class="title">{{cat.name}}</div>
      </div>
    </div>
    <div class="qiang">
      <div class="list">
        <qiangList></qiangList>
      </div>
      <van-tag class="tag" mark type="danger">猜你喜欢</van-tag>
    </div>
    <div class="goods">
      <van-tabs v-model="active" sticky @change="tabChange" color="#1baeae" title-active-color="#1baeae" title-inactive-color="#1baeae">
        <van-tab  v-for="cat in tabCats" :key="cat.id" :name="cat.id" :title="cat.name">
          <van-list
            class="goodsList"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <!-- <van-cell v-for="item in goodsList" :key="item" :title="item.post_title" /> -->
            <div style="position: relative;"
              :to="'/shop/detail/'+item.id"
              class="item"
              v-for="(item,index) in goodsList"
              :key="index"
            >
            <van-tag class="huodongTag" v-if="item.goods_level==1" mark type="danger">活动</van-tag>
            <router-link :to="'/shop/detail/'+item.id">
              
              <van-image width="100%" height="50vw" fit="cover" radius="10px" :src="GLOBAL.IMG + item.thumbnail" />
              <div class="title">{{item.post_title}}</div>
            </router-link>
              <div style="display:flex;justify-content:space-between">
                  <div class="price">¥ {{item.price}}</div>
                  <div style="padding-right:10px;line-height:36px"><i class="iconfont iconfabu" style="color:#fff;" @click="addCart(item.id,item.n1)"></i></div>
              </div>
              
            </div>   
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
    <div class="ad-bot" v-if="adSeting.status">
        <i class="iconfont iconSearch-close ad-close" @click="closeAd"></i>
        <img :src="this.adSeting.thumbnail" @click="clickAd" />
    </div>
    <div style="height:64px"></div>
    <TabBar active="0" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
import qiangList from "./components/qiangList.vue";
import top from "./components/top.vue";
import vueSwpier from "@/components/vueSwiper.vue";
import Vue from "vue";
import { Tag } from "vant";
Vue.use(Tag);
import { List } from "vant";
import { Tab, Tabs } from "vant";
import wx from "weixin-js-sdk";
import wx_share from '../../common/wx_share.js';
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(List);

export default {
  name: "Home",
  components: {
    TabBar,
    vueSwpier,
    top,
    qiangList
  },
  data() {
    return {
      slide: [],
      goodsList: [],
      loading: false,
      finished: false,
      cPage: 1,
      categorys: [],
      active: 0,
      tabCats: [{ id: 0, name: "全部商品", more: {} }],
      currentCatId: 0,
      user: { token: "", user: {id:0, is_share: 0, customer_type: 0 } },
      buyDetail: {
        goods_id: 0,
        num: 1,
        attr_json: { n1: "", n2: "", n3: "" },
      },
      adSeting:{
          status:0,
          thumbnail:'',
          url:'',
      }
    };
  },
  methods: {
    
    getLocation() {
      let linker = location.href.split("#")[0];
      this.$http
        .post(
          this.GLOBAL.API + "weixin/public/getconfig",
          { url: linker },
          { params: {}, headers: {} }
        )
        .then(response => {
          let data = response.body;
          let d = data.data;
          wx.config({
            debug: false,
            appId: d["appId"], // 必填，公众号的唯一标识
            timestamp: d["timestamp"], // 必填，生成签名的时间戳
            nonceStr: d["noncestr"], // 必填，生成签名的随机串
            signature: d["signature"], // 必填，签名
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"] // 必填，需要使用的JS接口列表
          });
          wx.ready(() => {
            wx.getLocation({
              type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: res => {
                this.getNearbyCommunity(res.longitude, res.latitude);
              }
            });
          });
        });
    },
    getNearbyCommunity(lng, lat) {
      this.$http
        .get(this.GLOBAL.API + "/map/map/index", {
          params: { lng: lng, lat: lat, coummunity_id: "" },
        //   params: { lng: 116.450019, lat: 39.778179, coummunity_id: "",lng2:lng,lat2:lat },//没有获取地址，调试时候用。
          headers: {}
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            localStorage.setItem(
              "community",
              JSON.stringify(data.data.nearest_community[0])
            );
            localStorage.setItem("city",JSON.stringify({"area_id":data.data.nearest_community[0]['city_id'],"area_name":data.data.nearest_community[0]['city']}))
          }
        });
    },
    addCart(id,n1){
        if(!this.user.token){
            this.$router.push("/login");
        }
        if(n1){
            console.log(n1);
            this.$router.push("/shop/detail/"+id);
        }else{
            //加购物车
            this.$http.post(
                this.GLOBAL.API + "s_shop/cart/addCart",
                {
                    post_id: id,
                    attr_json: JSON.stringify(this.buyDetail.attr_json),
                },
                {
                    params: {},
                    headers: {
                    "XX-Token": this.user.token,
                    "XX-Device-Type": "mobile",
                    },
                }
                )
                .then((response) => {
                    let data = response.body;
                    this.$toast(data.msg);
                });
        }
    },

    getSlide() {
      this.$http
        .get(this.GLOBAL.API + "s_slide/index/slide?id=3", {
          params: {},
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.slide = data.data;
          }
        });
    },
    onLoad() {
      this.getGoodsList();
    },
    tabChange(name) {
      this.loading = false;
      this.finished = false;
      this.cPage = 1;
      this.goodsList = [];
      this.currentCatId = name;
      this.getGoodsList();
    },
    getCategory() {
      this.$http
        .get(this.GLOBAL.API + "s_shop/category/listBig", {
          params: { pid: 0 },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            for (let i in data.data) {
              data.data[i].pic =
                this.GLOBAL.IMG + JSON.parse(data.data[i].more).thumbnail;
            }
            this.categorys = data.data; //= data.data.data;
            this.tabCats = this.tabCats.concat(this.categorys);
          }
        });
    },
    getGoodsList() {
      this.$http
        .get(this.GLOBAL.API + "s_shop/goods/goodsList", {
          params: { cid: this.currentCatId, page: this.cPage },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.loading = false;
          if (this.cPage >= data.data.last_page) {
            this.finished = true;
          } else {
            this.cPage++;
          }
          if (data.code == 1) {
            this.goodsList = this.goodsList.concat(data.data.data); //= data.data.data;
          }
        });
    },
    getSetting(){
      this.$http
        .get(this.GLOBAL.API + "s_setting/Setting/getHomeAd", {
          params: { },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          
          if (data.code == 1) {
            this.adSeting=data.data;
            if(this.adSeting.status){
                console.log(localStorage.getItem('adTime'));
                    console.log(new Date().getTime()/1000)
                if(localStorage.getItem('adTime')> new Date().getTime()/1000){
                    
                    this.adSeting.status=0;
                }
            }
          }
        });
    },
    closeAd(){
      localStorage.setItem("adTime", new Date().getTime()/1000+1*6*3600);
      this.adSeting.status = 0;
    },
    clickAd(){
        window.location.href=this.adSeting.url;
        //this.$router.push("hui/list");
    }
  },
  
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    this.getSetting();
    this.getSlide();
    this.getCategory();
    let item = {"post_title":"亿家一家社区商城","desc":"亿万家庭，汇聚一家！为您提供便捷的生活服务，邻居家人朋友都在关注","thumbnail":"http://yijia.sihandbms.cn/upload/default/logo.jpg"}
    wx_share.wx_share(this.GLOBAL.API,this.user,item);
    if (this.$route.query.share) {
      localStorage.setItem("share", this.$route.query.share);
    }
    localStorage.setItem('community','{"name":"正在获取位置","id":"0"}');
    this.getLocation();
    window.CateListScrollTop = 0;
  },
  beforeRouteLeave (to, from, next) {
//离开该页面的时候把高度记录
    window.CateListScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    next()
  },
  activated() { 
//返回的时候滚动到记录的高度
//延时200ms，不延迟滚动的话，有商品页内容高度比较小的情况就返不回原来的位置
    setTimeout(() => {
      window.scrollTo(0, window.CateListScrollTop);
    }, 200);
  }
};
</script>
<style lang="scss" scoped>
.home {
  //background-color: #f9f9f9;
  //background: linear-gradient(to right,#780001,#d3512f,#780001);
  //background: linear-gradient(to right,#CBC9CC,#CBC9CC,#CBC9CC);
  //background: linear-gradient(to right,#1baeae,#1baeae,#1baeae);
  position: relative;
}
.goodsList {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  background-color: #1baeae;
  .item {
    margin: 6px 0 0 0;
    //background-color: #fff;
    background: linear-gradient(to right,#1baeae,#1baeae,#1baeae);
    //background: linear-gradient(to right,#c02c38,#c02c38,#c02c38);

    //background-color: #ba1f21;
    //background: linear-gradient(to right,#780001,#d3512f,#780001);
    width: 49%;
    border-radius: 10px;
    border: 1px solid #fff;
    .huodongTag{
        position: absolute;
        z-index: 999;
        top:0;
        left:0;
    }
    .title {
      text-align: left;
      line-height: 20px;
      height: 40px;
      overflow: hidden;
      padding: 0px 5px 0px 5px;
      //color: #333;
      //color: #222333;
      color: #fff;
    }
    .price {
      //color: #F40;
      //color: #1baeae;
      color: #fff;
      text-align: left;
      padding: 8px 5px;
    }
  }
}
.cats {
  margin-top: 10px;
  padding: 15px 0 10px 0;
  background-color: #fff;
  //background: linear-gradient(to right,#780001,#d3512f,#780001);
  //background: linear-gradient(to right,#CBC9CC,#CBC9CC,#CBC9CC);
  //background: linear-gradient(to right,#1baeae,#1baeae,#1baeae);
  display: flex;
  flex-wrap: wrap;
  .cat {
    width: 20%;
    padding-bottom: 10px;
    .title {
      // color: #333;
      color: #222333;
    }
    img {
      width: 45px;
      height: 45px;
    }
  }
}
.qiang {
  background-color: #fff;
  //background: linear-gradient(to right,#780001,#d3512f,#780001);
  //background: linear-gradient(to right,#CBC9CC,#CBC9CC,#CBC9CC);
  //background: linear-gradient(to right,#1baeae,#1baeae,#1baeae);
  position: relative;
  .title {
    text-align: left;
  }
  .list {
    height: 250px;
    overflow: auto;
    //background-color: #ba1f21;
    //background: linear-gradient(to right,#780001,#d3512f,#780001);
    //background: linear-gradient(to right,#CBC9CC,#CBC9CC,#CBC9CC);
  }
  .tag {
    
    position: absolute;
    top: 0;
    left: 0;
  }
}
.ad-bot{
    position:fixed;
    bottom:60px;
    z-index: 999;
    width:100%;
    height: 28vw;
    overflow: hidden;
    opacity:0.9;
    .ad-close{
        position: absolute;
        top:0;
        right:3px;
        font-size: 28px;
    }
    img{
        width:100%;
    }
    
}

</style>